var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.1182,
    cy: 31,
    r: 31,
    fill: "#21222D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2136 24.2865C21.3866 23.708 21.9264 23.2815 22.558 23.2815H40.51C41.1416 23.2815 41.6813 23.708 41.8544 24.2865L31.534 31.5108L21.2136 24.2865ZM19.4725 24.67C19.4724 24.6781 19.4724 24.6862 19.4725 24.6943V38.148C19.4725 39.8469 20.859 41.2335 22.558 41.2335H40.51C42.2089 41.2335 43.5955 39.8469 43.5955 38.148V24.6943M41.9125 26.3002V38.148C41.9125 38.9174 41.2794 39.5505 40.51 39.5505H22.558C21.7885 39.5505 21.1555 38.9174 21.1555 38.148V26.3002L31.0514 33.2273C31.3412 33.4302 31.7268 33.4302 32.0166 33.2273L41.9125 26.3002ZM43.5955 24.67C43.5879 22.9774 42.2043 21.5984 40.51 21.5984H22.558C20.8637 21.5984 19.4801 22.9774 19.4725 24.67",
    fill: "#CC3333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.b8c7c8e54400cdd974675a89b77959a1.svg";
export { ForwardRef as ReactComponent };